<div class="container-flex">
  <div class="tabla-container">
    <p class="leyenda">
      Frames tal como llegaron del dispositivo. Se conservan los de las últimas
      48 horas.
    </p>

    <app-tabla
      [totalCount]="totalCount"
      [datos]="logs"
      [columnas]="columnas"
      [name]="name"
      [pageSizeOptions]="helper.pageSizeOptions"
      [search]="search"
      [(query)]="query"
      (queryChange)="listar()"
      [paginatorArriba]="false"
      [filtros]="filtros"
      [emptyState]="{ title: 'Todavía no hay frames de este dispositivo' }"
    ></app-tabla>
  </div>

  @if (logSeleccionado) {
    <div class="detalles-container">
      <app-detalles-log-generico
        [title]="'Detalles del frame'"
        [data]="logSeleccionado"
        (close)="cerrarDetalles()"
      ></app-detalles-log-generico>
    </div>
  }
</div>
